export default "__VITE_ASSET__znm1ebEA__"